module.exports = __webpack_public_path__ + "img/pk.dc971df3.png";